import type { Etapa } from "../lib/api";
import { n } from "../lib/format";

interface Props {
  etapa: Etapa;
  onClick?: (etapa: Etapa) => void;
}

// Replica a lógica VER-COR do painel_producao legado.
export function corEtapa(qtd: number, min: number, max: number): "azul" | "verde" | "amarelo" | "vermelho" {
  if (qtd <= 0) return "azul";
  if (qtd < min) return "verde";
  if (qtd <= max) return "amarelo";
  return "vermelho";
}

export function CardEtapa({ etapa, onClick }: Props) {
  const cor = corEtapa(etapa.quantidade, etapa.minimoNivel, etapa.maximoNivel);
  return (
    <div className={`card-etapa cor-${cor}`} onClick={() => onClick?.(etapa)}>
      <div className="titulo">{etapa.descricao}</div>
      <div className="valor">{n(etapa.quantidade)}</div>
      {etapa.atrasadas > 0 && (
        <div className="atrasadas">
          {/* painel_producao TELA-1.prc L2308-2313: STRING "ATRASADAS : " + quantidade (só se > 0) */}
          <span>ATRASADAS : {n(etapa.atrasadas)}</span>
        </div>
      )}
    </div>
  );
}
